import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/Users/allen/dev/git/bohm/cde/frontend-legacy/app/providers/ThemeProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserCredentialProvider"] */ "/Users/allen/dev/git/bohm/cde/frontend-legacy/components/auth/UserCredentialProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/allen/dev/git/bohm/cde/frontend-legacy/components/common/NotificationMenu/component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/allen/dev/git/bohm/cde/frontend-legacy/components/common/ScrollableTabs/ScrollableTabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/allen/dev/git/bohm/cde/frontend-legacy/components/header/ThemeToggle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AvatarMenu"] */ "/Users/allen/dev/git/bohm/cde/frontend-legacy/components/layout/AvatarMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/allen/dev/git/bohm/cde/frontend-legacy/components/layout/Header/SearchIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SearchStateResetProvider"] */ "/Users/allen/dev/git/bohm/cde/frontend-legacy/components/providers/SearchStateResetProvider.tsx");
;
import(/* webpackMode: "eager" */ "/Users/allen/dev/git/bohm/cde/frontend-legacy/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/Users/allen/dev/git/bohm/cde/frontend-legacy/node_modules/next/dist/client/link.js");
